export const APP_MARGIN = 24;
export const GRID_SPACING = 40;
export const TITLE_MARGIN = '60px';
export const FORM_WIDTH = 590;
export const FORM_SPACING = 190;
